import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const fetchSortingFields = createProvider(api.fetchSortingFields)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch sorting fields aborted');
    } else {
      console.error('Fetch sorting fields was failed:', error);
    }
    throw error;
  });
